import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Flag',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M4.69 4.05c-.1-.4-.5-.64-.9-.53-.4.1-.64.5-.53.9l4.82 19.03c.08.32.38.55.71.55.06 0 .12-.01.18-.02.39-.1.63-.5.54-.89v-.01L4.69 4.05zm16.06 5.36c-.78-2.9-1.57-5.81-2.36-8.71a.79.79 0 0 0-.79-.69C13.17-.3 10.27 4.1 5.85 3.78c-.35-.04-.57.13-.48.45.78 2.9 1.56 5.81 2.35 8.71.08.38.41.66.8.68 4.42.32 7.33-4.08 11.75-3.76.34.05.57-.14.48-.45zm-3.47-8.3c.22.8.43 1.6.65 2.4-.9.03-1.78.22-2.62.54-.22-.8-.43-1.6-.65-2.4a8.11 8.11 0 0 1 2.62-.54zm-9.11 8.98c-.25-.91-.49-1.82-.75-2.73.95-.03 1.88-.24 2.75-.6-.22-.8-.43-1.6-.65-2.4.88-.41 1.74-.86 2.57-1.36.22.8.43 1.6.65 2.4-.83.5-1.68.96-2.56 1.36.24.91.49 1.82.74 2.73-.88.37-1.81.57-2.75.6zm3.41 1.84l-.66-2.44c.87-.4 1.72-.86 2.55-1.35l.66 2.44c-.83.5-1.68.95-2.55 1.35zm1.9-3.8c-.24-.91-.49-1.82-.74-2.73.83-.5 1.68-.95 2.57-1.35.24.91.49 1.82.74 2.73-.88.41-1.74.85-2.57 1.35zm3.25 1.1l-.66-2.44c.83-.32 1.71-.5 2.6-.54l.66 2.44c-.89.03-1.77.21-2.6.54z" }
      })]
    );
  }
};